import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import CRLogoAnimation from "../../components/CRLogoAnimation";
import { GAME_STATUS_CORRECT_ANSWER, setGameInstrOverlayStatus } from "../../actions/game";

class GameStatusContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showAnimation: false
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.gameStatus === GAME_STATUS_CORRECT_ANSWER && this.props.gameStatus !== prevProps.gameStatus) {
      this.setState({showAnimation: true});
    }
  }

  render() {
    const { Child, childOptions, gameStatus } = this.props;

    return (
      <CRLogoAnimation
        show={this.state.showAnimation}
        transitionOut={()=>this.setState({showAnimation: false})}
        openInstr={this.props.setGameInstrOverlayStatus}
      />
    );
  }
}

const mapStateToProps = state => ({
  gameStatus: state.game.status,
});

const mapDispatchToProps = dispatch => ({
  setGameInstrOverlayStatus: ()=> {
    dispatch(setGameInstrOverlayStatus());
  },
});

GameStatusContainer.propTypes = {
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(GameStatusContainer);



// WEBPACK FOOTER //
// ./src/containers/ChainReactionGame/GameStatusContainer.js